import React from "react";
import { H4 } from "../../../../AbstractElements";
import { FormGroup, Label } from "reactstrap";

export default function UsersPermissions({ register, handleAll }) {
  return (
    <>
      {" "}
      <H4 attrH4={{ className: "mb-0" }}>Usuarios</H4>
      <FormGroup className="m-t-15 m-checkbox-inline m-0">
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="list_user"
            type="checkbox"
            {...register("permissions.list_user", {})}
          />
          <Label for="list_user">
            {Option}
            <span className="digits"> Ver</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="create_user"
            type="checkbox"
            {...register("permissions.create_user", {})}
          />
          <Label for="create_user">
            {Option}
            <span className="digits"> Crear</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="edit_user"
            type="checkbox"
            {...register("permissions.edit_user", {})}
          />
          <Label for="edit_user">
            {Option}
            <span className="digits"> Modificar</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="delete_user"
            type="checkbox"
            {...register("permissions.delete_user", {})}
          />
          <Label for="delete_user">
            {Option}
            <span className="digits"> Eliminar</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            onChange={handleAll}
            className="p-0 m-0"
            id="user"
            type="checkbox"
          />
          <Label for="user">
            {Option}
            <span className="digits"> Todos</span>
          </Label>
        </div>
      </FormGroup>
    </>
  );
}
